const sanitizeEnvValue = (value) => {
  if (!value) return "";
  return value.replace(/^"+|"+$/g, "");
};

export const APP_CONFIG = {
  JOI_JO_ID: sanitizeEnvValue(process.env.REACT_APP_JOI_JO_ID),
};